import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import {SmOverflowTooltipModule} from '../../components/sm-overflow-tooltip/sm-overflow-tooltip.module';
import { SmInputComponent } from './sm-input.component';

@NgModule({
  declarations: [SmInputComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SmOverflowTooltipModule,
  ],
  exports: [SmInputComponent],
})
export class SmInputModule {}
